export const filterProperty = <T>(array: T[], getter: (v: T) => string, filter: string) => {
	const filters = filter?.toLowerCase().split(" ")
	for (const filter of filters) {
		array = array.filter((item: any) => (getter(item) || "").toLowerCase().includes(filter))
	}
	return array
}
